// SignUpEmailSent.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    maskedEmail, replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    DEV_ENABLED, VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

const { styled, Card, Stack } = mui;

// const CustomCard = styled(Card)(({ theme }) => ({
//     display: 'flex',
//     flexDirection: 'column',
//     alignSelf: 'center',
//     width: '100%',
//     maxWidth: '450px',
//     padding: `${theme.spacing(4)} ${theme.spacing(1)}`, // Top-bottom: XXpx, Left-right: YYpx
//     gap: theme.spacing(2),
//     margin: 'auto',
//     boxShadow:
//     'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
//     [theme.breakpoints.up('sm')]: {
//     width: '450px',
//     },
//     ...theme.applyStyles('dark', {
//     boxShadow:
//         'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
//     }),
// }));

// const SignUpContainer = styled(Stack)(({ theme }) => ({
//     height: 'calc((1 - var(--template-frame-height, 0)) * 120dvh)',
//     minHeight: '100%',
//     padding: theme.spacing(2),
//     [theme.breakpoints.up('sm')]: {
//     padding: theme.spacing(4),
//     },
//     '&::before': {
//     content: '""',
//     display: 'block',
//     position: 'absolute',
//     zIndex: -1,
//     inset: 0,
//     backgroundImage:
//         'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
//     backgroundRepeat: 'no-repeat',
//     ...theme.applyStyles('dark', {
//         backgroundImage:
//         'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
//     }),
//     },
// }));

export default function PasswordReset(props){

    const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
    const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
    const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
    const { getTempCredential, sendEmail4PasswordReset, getEmailByUsername, postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();

    const [username, setUsername] = useState('');
    const [usernameError, setUsernameError] = useState(false);
    const [usernameErrorMessage, setUsernameErrorMessage] = useState('');    
    const [usernameClearButton, setUsernameClearButton] = useState(false);

    const [usernameFound, setUsernameFound] = useState(false);
    const [returnedEmail, setReturnedEmail] = useState('');

    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [emailErrorMessage, setEmailErrorMessage] = useState('');    
    const [emailClearButton, setEmailClearButton] = useState(false);

    const [message1On, setMessage1On] = useState(false);
    const [message1, setMessage1] = useState('');   
    const [message2On, setMessage2On] = useState(false);
    const [message2, setMessage2] = useState('');     
    
    const [loading4Home, setLoading4Home] = useState(false);

    const navigate = useNavigate();

    const handleOnClickEmail = async () => {

        if (email === returnedEmail){

            setMessage2On(false);
            setMessage2('');

            const tempCredential = await getTempCredential();

            if (tempCredential) {
                const item = {
                    Credential: tempCredential,
                    Email: email,
                    UserName: username,
                    DevEnabled: DEV_ENABLED,
                };      
                sendEmail4PasswordReset(item, 'PasswordReset');
                navigate('/password-reset-email-sent', { state: { username: username, email: email } });                
            }
            else {

            }          

        }
        else {
            setMessage2On(true);
            setMessage2('電子郵件地址不符');
        }
    }

    const handleOnChangeEmail = (e) => {
        let value = e.target.value.toLowerCase();
        value = value.replace(/\s+/g, '');
        if (value.length <= 50) {
            setEmail(value);
            setEmailClearButton(value.length > 0); // Show ClearIcon if input is not empty
        }          
    };

    const handleOnClickClearEmail = () => {
        setEmail('');
        setEmailClearButton(false); // Hide ClearIcon when input is cleared
    };

    const handleOnClickUsername = async () => {

        setLoading4Home(true);

        const tempCredential = await getTempCredential();

        if (tempCredential) {
            const item = {
                Credential: tempCredential,
                UserName: username,
            };      
            getEmailByUsername(item, 'PasswordReset')
            .then(async (returnedEmail) => {
                if (returnedEmail.length > 0) {
                    setReturnedEmail(returnedEmail);
                    setMessage1On(true);
                    setMessage1(`輸入完整註冊電郵地址 ${maskedEmail(returnedEmail)}`);
                    setUsernameFound(true);
                    setLoading4Home(false);
                }
                else {
                    setMessage1On(true);
                    setMessage1('系統沒有記錄');
                    setUsernameFound(false);
                    setLoading4Home(false);
                }
            })      
        }
        else {
            setLoading4Home(false);
        }

        // getToken('tempToken', 'eyJhbGciOiJIUzI1NiIsInR5c', 5)
        // .then(async (token) => {
        //     if (token.length > 0) {
        //         const tempCredential = {
        //             UserName: 'tempToken',
        //             Token: token
        //         };
        //         const item = {
        //             Credential: tempCredential,
        //             UserName: username,
        //         };      
        //         getEmailByUsername(item, 'ForgotPassword')
        //         .then(async (returnedEmail) => {
        //             if (returnedEmail.length > 0) {
        //                 setReturnedEmail(returnedEmail);
        //                 setMessage1On(true);
        //                 setMessage1(`輸入完整註冊電郵地址 ${maskedEmail(returnedEmail)}`);
        //                 setUsernameFound(true);
        //                 setLoading4Home(false);
        //             }
        //             else {
        //                 setMessage1On(true);
        //                 setMessage1('系統沒有記錄');
        //                 setUsernameFound(false);
        //                 setLoading4Home(false);
        //             }
        //         })
        //     }
        // })      

    }

    const handleOnChangeUsername = (e) => {
        let value = e.target.value.toLowerCase();
        value = value.replace(/\s+/g, '');
        if (value.length <= 50) {
            setUsername(value);
            setUsernameClearButton(value.length > 0); // Show ClearIcon if input is not empty
        }          
    };

    const handleOnClickClearUsername = () => {
        setUsername('');
        setUsernameClearButton(false); // Hide ClearIcon when input is cleared
    };

    return (
        
        <div>

            <Container sx={{ mt: 10, mb: 4 }}>

                <Typography gutterBottom variant="h5" component="div">
                重設密碼
                </Typography>

                <Card sx={{ boxShadow: 'none', backgroundColor: '#eeeeee', padding: 2 }}>

                    <Grid container spacing={2}>

                        <Grid size={12}>

                            <Typography gutterBottom variant="h5" component="div" sx={{ color: '#bdbdbd' }}>
                            帳戶名稱
                            </Typography>

                            <Paper
                            component="form"
                            sx={{ boxShadow: 'none', display: 'flex', alignItems: 'center', width: '100%' }}
                            >

                            <InputBase
                                sx={{ ml: 1, flex: 1 }}
                                placeholder={'最長 50 個字串'}
                                value={username}
                                onChange={handleOnChangeUsername}
                            />

                            {usernameClearButton &&
                            <IconButton type="button" sx={{ p: '10px', borderRadius: 1 }} onClick={handleOnClickClearUsername}>
                                <ClearIcon  />
                            </IconButton>
                            }
                            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />                
                            <IconButton color="primary" sx={{ p: '10px', borderRadius: 1 }} onClick={handleOnClickUsername}>
                                <CheckIcon  />
                            </IconButton>

                            </Paper>

                        </Grid>   

                        {message1On && 
                        <Typography gutterBottom component="div" sx={{ color: '#bdbdbd' }}>
                        {message1}
                        </Typography>
                        }

                        {usernameFound &&
                        <Grid size={12}>

                            <Typography gutterBottom variant="h5" component="div" sx={{ color: '#bdbdbd' }}>
                            電郵地址
                            </Typography>

                            <Paper
                            component="form"
                            sx={{ boxShadow: 'none', display: 'flex', alignItems: 'center', width: '100%' }}
                            >

                            <InputBase
                                sx={{ ml: 1, flex: 1 }}
                                placeholder={'最長 50 個字串'}
                                value={email}
                                onChange={handleOnChangeEmail}
                            />

                            {emailClearButton &&
                            <IconButton type="button" sx={{ p: '10px', borderRadius: 1 }} onClick={handleOnClickClearEmail}>
                                <ClearIcon  />
                            </IconButton>
                            }
                            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />                
                            <IconButton color="primary" sx={{ p: '10px', borderRadius: 1 }} onClick={handleOnClickEmail}>
                                <CheckIcon  />
                            </IconButton>

                            </Paper>

                        </Grid>                               

                        }

                        {message2On && 
                        <Typography gutterBottom component="div" sx={{ color: '#bdbdbd' }}>
                        {message2}
                        </Typography>
                        }

                    </Grid>

                </Card>

            </Container>

            <Box sx={{ paddingTop: '100px', display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography sx={{ textAlign: 'center' }}>
                <Link
                    to='/signin'
                    variant='body2'
                    sx={{ alignSelf: 'center' }}
                >
                    登入頁面
                </Link>
                </Typography>
            </Box> 

            {loading4Home && <ClipLoader1 />}

        </div>

    );
};